import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

export default class extends Controller {
  static targets = ["planGroupSelect", "planSelect", "planOption"]

  connect() {
    this.modal = new Modal(this.element)
    this.modal.show()
  }

  disconnect() {
    this.modal.hide()
  }

  filterPlans() {
    const selectedGroupId = this.planGroupSelectTarget.value

    const optionsTemplate = this.planOptionTargets.find(template => {
      return template.dataset.planGroupId === selectedGroupId
    })

    this.planSelectTarget.innerHTML = optionsTemplate?.innerHTML || ""
    this.planSelectTarget.value = ""
  }
}
